/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Notice_EmptyInputs */

const en_us2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is left to train with this equipment and this recovery. Try another focus or another gym.`)
};

const pt_br2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não sobrou nada para treinar com esse equipamento e essa recuperação. Tente outro foco ou outra academia.`)
};

const es_419_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No queda nada para entrenar con este equipo y esta recuperación. Prueba otro enfoque u otro gimnasio.`)
};

const pt_pt2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não sobrou nada para treinar com este equipamento e esta recuperação. Experimenta outro foco ou outro ginásio.`)
};

const fr_fr2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus rien à travailler avec cet équipement et cette récupération. Essaie un autre focus ou une autre salle.`)
};

const de_de2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dieser Ausrüstung und dieser Erholung bleibt nichts zu trainieren. Versuch einen anderen Fokus oder ein anderes Studio.`)
};

const it_it2_quick_workout_notice_empty = /** @type {(inputs: Quick_Workout_Notice_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non resta niente da allenare con questa attrezzatura e questo recupero. Prova un altro focus o un'altra palestra.`)
};

/**
* | output |
* | --- |
* | "Nothing is left to train with this equipment and this recovery. Try another focus or another gym." |
*
* @param {Quick_Workout_Notice_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_notice_empty = /** @type {((inputs?: Quick_Workout_Notice_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Notice_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_notice_empty(inputs)
	if (locale === "es-419") return es_419_quick_workout_notice_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_notice_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_notice_empty(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_notice_empty(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_notice_empty(inputs)
	return en_us2_quick_workout_notice_empty(inputs)
});
export { quick_workout_notice_empty as "quick-workout.notice_empty" }